// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../../shared/components/editable-field';
import FileAttachmentPanel from '../../../../../shared/components/file-attachment-panel';
import {FormattedMessage} from 'react-intl';
import InformationRequestFormStruct from '../../../state/information-request-form';
import LabeledFormInput from '../../../../../shared/components/labeled-form-input';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import Questions from './questions';
import ReturnStatusSelect from '../return-status-select';
import {isInfoRequestFormInvalid} from '../../../services/is-form-valid';

function handleCommentsChange(event) {

    this.onCommentsChange(event.target.value);

}

const InformationRequestForm = props =>
    <section className={`information-request-form ${props.isEditableAndAccessible ? 'is-editable' : null}`}>
        <Questions
            isEditableAndAccessible={props.isEditableAndAccessible}
            onAnswerChange={props.onAnswerChange}
            questions={props.informationRequestForm.questions}
        />

        <ReturnStatusSelect
            errorMessage='INFO_REQUEST_STATUS_ERROR'
            fieldLabel='INFORMATION_REQUEST_STATUS'
            isEditableAndAccessible={props.isEditableAndAccessible}
            isValid={!(props.informationRequestForm.returnStatus.id === '7' && props.informationRequestForm.questions.some(question => question.answer !== ''))}
            onPartReturnStatusChange={props.onInfoRequestStatusChange}
            partReturn={props.partReturn}
            returnStatus={props.informationRequestForm.returnStatus.id}
        />
        <LabeledFormInput
            className={`info-request-comments ${props.informationRequestForm.returnStatus.id === '7' ? 'required' : ''}`}
            label='COMMENTS'
        >
            <EditableField
                isEditable={props.isEditableAndAccessible}
                value={props.informationRequestForm.courierInfo.comments}
            >
                <textarea
                    maxLength={250}
                    onChange={props::handleCommentsChange}
                    value={props.informationRequestForm.courierInfo.comments}
                />
            </EditableField>
        </LabeledFormInput>
        <FileAttachmentPanel
            files={props.informationRequestForm.files}
            isUploadAllowed={props.isEditableAndAccessible}
            onFileDelete={props.onFileDelete}
            onFileUploadSuccess={props.onFileUploadSuccess}
            serviceConfig={{
                className: 'BUS2222',
                classType: 'BO',
                objectKey: `RGA${props.partReturn.rgaNumber}${props.partReturn.claimNumber}`
            }}
        />
        <div className='info-button-group'>
            <button
                className='button'
                onClick={props.onCancelButtonClick}
            >
                <FormattedMessage id='CANCEL'/>
            </button>
            {props.isEditableAndAccessible &&
                <button
                    className='button-primary'
                    disabled={!props.isFormDirty || isInfoRequestFormInvalid(props.informationRequestForm.returnStatus.id, props.informationRequestForm)}
                    onClick={props.onSubmitButtonClick}
                >
                    <FormattedMessage id='SUBMIT'/>
                </button>
            }
        </div>
    </section>;

InformationRequestForm.displayName = 'InformationRequestForm';
InformationRequestForm.propTypes = {
    informationRequestForm: PropTypes.instanceOf(InformationRequestFormStruct).isRequired,
    isEditableAndAccessible: PropTypes.bool.isRequired,
    isFormDirty: PropTypes.bool.isRequired,
    onAnswerChange: PropTypes.func.isRequired,
    onCancelButtonClick: PropTypes.func.isRequired,
    onCommentsChange: PropTypes.func.isRequired,
    onFileDelete: PropTypes.func.isRequired,
    onFileUploadSuccess: PropTypes.func.isRequired,
    onInfoRequestStatusChange: PropTypes.func.isRequired,
    onSubmitButtonClick: PropTypes.func.isRequired,
    partReturn: PropTypes.instanceOf(PartReturn).isRequired
};

export default InformationRequestForm;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/form-fields/information-request-form/index.js